import React from 'react';

const Hashingee = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="165"
      height="104"
      viewBox="0 0 165 104"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M123.492 94.9249C151.832 97.7151 165 71.9684 165 43.4912C165 15.0139 141.425 -3.52955 113.244 0.565282C94.7344 3.25489 92.807 16.7697 64.3888 9.33092C56.7285 7.03833 54.1753 5.55 46.213 5.72154C17.7357 5.72154 0 27.7757 0 56.2529C0 84.7302 17.7357 103.368 46.213 103.368C73.4767 102.079 75.0726 94.4625 91.2658 90.9288C107.459 87.395 113.151 93.9067 123.492 94.9249Z"
        fill="#E7E7E7"
      />
      <ellipse
        cx="29.2675"
        cy="33.6598"
        rx="2.58334"
        ry="3.66699"
        transform="rotate(-6.30816 29.2675 33.6598)"
        fill="#4C4135"
      />
      <ellipse
        cx="54.4989"
        cy="30.8697"
        rx="2.58334"
        ry="3.66699"
        transform="rotate(-6.30816 54.4989 30.8697)"
        fill="#4C4135"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.2779 45.8123C48.0826 45.619 48.8545 44.1117 48.8545 42.1385C48.8545 40.1653 47.2115 38.8551 45.2559 39.1641C43.9248 39.3744 43.4274 40.5039 41.7603 39.8206C41.2836 39.6278 41.161 39.6112 40.5951 39.575C38.615 39.575 37.3818 41.0495 37.3818 43.0228C37.3818 44.996 38.9482 46.5213 40.9283 46.5213C42.6942 46.4471 43.0552 46.1346 43.9576 45.8123C44.8599 45.4901 45.6095 45.884 46.2779 45.8123Z"
        fill="#FF2C20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.4518 39.576C40.3386 39.7784 40.2802 40.0146 40.2953 40.2633C40.3373 40.9552 40.9322 41.4821 41.6241 41.4401L44.729 41.2518C45.4209 41.2099 45.9478 40.615 45.9058 39.9231C45.887 39.6124 45.7567 39.335 45.5561 39.1274C45.457 39.1349 45.3568 39.1465 45.2558 39.1625C44.7785 39.2379 44.4084 39.4315 44.0532 39.6173C43.4176 39.9497 42.8296 40.2573 41.7602 39.819C41.2835 39.6261 41.1609 39.6096 40.595 39.5734C40.5468 39.5734 40.4991 39.5742 40.4518 39.576Z"
        fill="white"
      />
    </svg>
  );
};

export default Hashingee;
